import { FeatureFlags, THROTTLE_MS } from '@src/config/constants';
import { type ReactElement } from 'react';
import { nanoid } from 'nanoid';

export function sleep(milliseconds: number) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export function throttle(ms: number = THROTTLE_MS) {
  return FeatureFlags.ThrottlingEnabled ? sleep(ms) : Promise.resolve();
}

export const tryParseJson = <T = object>(value: string): T | undefined => {
  try {
    return JSON.parse(value) as T;
  } catch {
    return undefined;
  }
};

export function times(element: ReactElement, count: number): ReactElement[] {
  return Array.from({ length: count }, () => {
    return { ...element, key: nanoid() };
  });
}
